module.exports = __webpack_public_path__ + "static/media/Soybean14R7.dd1b8e82.PNG";